
import { useFilter } from '../../../filter/hook'
import { useQuery } from 'react-query'
import dataAPI from '../../services/dataAPI'
import { getPrevFilter, getNextFilter } from '../../../filter/utils/prefetchFilters'

export default function useFrequencyCore() {

  const{filter} = useFilter()
  const prevFilter = getPrevFilter(filter);
  const nextFilter = getNextFilter(filter);

  const frequencyQuery = useQuery({
    queryKey: ['frequency-consumption', filter],
    queryFn: () => dataAPI.getFrequencySingleCounter(filter)
})

  // Préchargement des données pour les fenêtres précédente et suivante
  useQuery({
    queryKey: ['frequency-consumption', prevFilter],
    queryFn: () => dataAPI.getFrequencySingleCounter(prevFilter),
    enabled: !!filter.device_name,
    staleTime: 5 * 60 * 1000,
  });

  useQuery({
    queryKey: ['frequency-consumption', nextFilter],
    queryFn: () => dataAPI.getFrequencySingleCounter(nextFilter),
    enabled: !!filter.device_name,
    staleTime: 5 * 60 * 1000,
  });
  return{
      
      filter,
      frequencyQuery : {
        data : frequencyQuery.data,
        isLoading : frequencyQuery.isLoading,
        isSuccess : frequencyQuery.isSuccess,
        isError : frequencyQuery.isError,
        error : frequencyQuery.error,
        refetch : frequencyQuery.refetch,
        isRefetching : frequencyQuery.isRefetching
      },
  }
}
